import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { getAllUsers, updateUser } from 'src/actions/loginAction';
import MessageModal from '../Pages/MessageModel';
import { Link } from 'react-router-dom'; 
import { sendConfirmationSms } from 'src/actions/smsActions'; 
const ChangePassword = (props) => {
  const dispatch = useDispatch();
  const hospitalID = parseInt(localStorage.getItem('hospitalCode'), 10);

  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const { oldPassword, newPassword, confirmPassword } = formData;

  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [modalVariant, setModalVariant] = useState('info');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    props.getAllUsers();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const currentUser = props.userList.find(
      (user) => parseInt(user.hospitalID, 10) === hospitalID
    );

    if (!currentUser) {
      setIsLoading(false);
      setModalTitle('User Not Found');
      setModalMessage('We couldn’t find your account. Please log in again or contact support.');
      setModalVariant('error');
      setModalShow(true);
      return;
    }

    if (currentUser.password !== oldPassword) {
      setIsLoading(false);
      setModalTitle('Incorrect Old Password');
      setModalMessage('The old password you entered is incorrect. Please try again.');
      setModalVariant('warning');
      setModalShow(true);
      return;
    }

    if (newPassword !== confirmPassword) {
      setIsLoading(false);
      setModalTitle('Password Mismatch');
      setModalMessage('New password and confirm password do not match. Please check and try again.');
      setModalVariant('warning');
      setModalShow(true);
      return;
    }

    const payload = {
      hospitalID: currentUser.hospitalID,
      username: currentUser.username,
      password: newPassword,
      first_name: currentUser.first_name,
      last_name: currentUser.last_name,
      email: currentUser.email,
      mobile: currentUser.mobile,
      role: currentUser.role,
      app_status: currentUser.app_status
    };

    try {
      await dispatch(updateUser(payload));
      const smsPayload = {
            hid: "2",
            recipientPhone: currentUser.mobile, 
            eventId: "MEDISEVAS_APP_PASSWORD_CHANGED_SUCCESSFUL", 
            templateData: {
                securityLink: "https://medisevas.com" 
            }
        };
        dispatch(sendConfirmationSms(smsPayload));
        
      props.getAllUsers();
      setModalTitle('Password Updated');
      setModalMessage('Your password has been updated successfully.');
      setModalVariant('success');
      setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      setModalTitle('Update Failed');
      setModalMessage('An error occurred while updating your password. Please try again.');
      setModalVariant('error');
    } finally {
      setIsLoading(false);
      setModalShow(true);
    }
  };

  return (
    <div className="mb-5">
      <div className="page-header filter-bar rounded ">
                <div className="row align-items-center">
                    <div className="col">
                        <h4 className="page-title">Change-Password</h4>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/doctor/dashboard">Patient Dashboard</Link></li>
                            <li className="breadcrumb-item active">Change-password</li>
                        </ul>
                    </div>
                </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6">
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label>Old Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="oldPassword"
                    value={oldPassword}
                    onChange={handleChange}
                    placeholder="Enter your current password"
                    required
                    disabled={isLoading}
                  />
                </div>
                <div className="form-group mb-3">
                  <label>New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="newPassword"
                    value={newPassword}
                    onChange={handleChange}
                    placeholder="Enter your new password"
                    required
                    disabled={isLoading}
                  />
                </div>
                <div className="form-group mb-4">
                  <label>Confirm New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={handleChange}
                    placeholder="Re-enter your new password"
                    required
                    disabled={isLoading}
                  />
                </div>
                <div className="submit-section text-center">
                  {/* <button
                    type="submit"
                    className="btn btn-info rounded-pill "
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : (
                      'Update Password'
                    )}
                  </button> */}
                  <button
  type="submit"
  className="btn btn-info rounded-pill"
  disabled={isLoading || props.smsLoading} // दोनों में से कोई भी लोडिंग हो तो बटन बंद हो जाएगा
>
  {isLoading || props.smsLoading ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      {isLoading ? 'Updating Password...' : 'Sending SMS...'} 
    </>
  ) : (
    'Update Password'
  )}
</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Modal */}
      <MessageModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        title={modalTitle}
        message={modalMessage}
        variant={modalVariant}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userList: Array.isArray(state.loginReducer?.userList?.data)
    ? state.loginReducer.userList.data
    : [],
    smsLoading: state.sms.loading
});

export default connect(mapStateToProps, { getAllUsers })(ChangePassword);
